<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
import echarts from 'echarts'
// require('echarts/theme/macarons') // echarts theme
import resize from './mixins/resize'

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '350px'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    showSymbol: {
      type: Boolean,
      default: false
    },
    borderWidth: {
      type: Number,
      default: 12
    },
    chartData: {
      type: Object,
      required: true
    },
    unitName: {
      type: String,
      default: 'sgChart'
    }
  },
  data() {
    return {
      chart: null,
      // 定义6种折线的样式
      defaultSeries: [{
        name: '',
        type: 'line',
        data: null,
        smooth: false,
        symbol: 'circle',
        symbolSize: 5,
        showSymbol: this.showSymbol,
        // areaStyle: {
        //   normal: {
        //     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
        //       offset: 0,
        //       color: 'rgba(137, 189, 27, 0.3)'
        //     }, {
        //       offset: 0.8,
        //       color: 'rgba(137, 189, 27, 0)'
        //     }], false),
        //     shadowColor: 'rgba(0, 0, 0, 0.1)',
        //     shadowBlur: 10
        //   }
        // },
        itemStyle: {
          normal: {
            color: 'rgb(137,189,27)',
            borderColor: 'rgba(137,189,2,0.27)',
            borderWidth: this.borderWidth
          }
        }
      }, {
        name: '',
        type: 'line',
        data: null,
        smooth: false,
        symbol: 'circle',
        symbolSize: 5,
        showSymbol: this.showSymbol,
        // areaStyle: {
        //   normal: {
        //     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
        //       offset: 0,
        //       color: 'rgba(0, 136, 212, 0.3)'
        //     }, {
        //       offset: 0.8,
        //       color: 'rgba(0, 136, 212, 0)'
        //     }], false),
        //     shadowColor: 'rgba(0, 0, 0, 0.1)',
        //     shadowBlur: 10
        //   }
        // },
        itemStyle: {
          normal: {
            color: 'rgb(0,136,212)',
            borderColor: 'rgba(0,136,212,0.2)',
            borderWidth: this.borderWidth
          }
        }
      }, {
        name: '',
        type: 'line',
        data: null,
        smooth: false,
        symbol: 'circle',
        symbolSize: 5,
        showSymbol: this.showSymbol,
        // areaStyle: {
        //   normal: {
        //     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
        //       offset: 0,
        //       color: 'rgba(219, 50, 51, 0.3)'
        //     }, {
        //       offset: 0.8,
        //       color: 'rgba(219, 50, 51, 0)'
        //     }], false),
        //     shadowColor: 'rgba(0, 0, 0, 0.1)',
        //     shadowBlur: 10
        //   }
        // },
        itemStyle: {
          normal: {
            color: 'rgb(219,50,51)',
            borderColor: 'rgba(219,50,51,0.2)',
            borderWidth: this.borderWidth
          }
        }
      }, {
        name: '',
        type: 'line',
        data: null,
        smooth: false,
        symbol: 'circle',
        symbolSize: 5,
        showSymbol: this.showSymbol,
        // areaStyle: {
        //   normal: {
        //     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
        //       offset: 0,
        //       color: 'rgba(127, 49, 27, 0.3)'
        //     }, {
        //       offset: 0.8,
        //       color: 'rgba(127, 49, 27, 0)'
        //     }], false),
        //     shadowColor: 'rgba(0, 0, 0, 0.1)',
        //     shadowBlur: 10
        //   }
        // },
        itemStyle: {
          normal: {
            color: 'rgb(127,49,27)',
            borderColor: 'rgba(127,49,27,0.2)',
            borderWidth: this.borderWidth

          }
        }
      }, {
        name: '',
        type: 'line',
        data: null,
        smooth: false,
        symbol: 'circle',
        symbolSize: 5,
        showSymbol: this.showSymbol,
        seriesName: '',
        // areaStyle: {
        //   normal: {
        //     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
        //       offset: 0,
        //       color: 'rgba(175,18,111, 0.3)'
        //     }, {
        //       offset: 0.8,
        //       color: 'rgba(175,18,111, 0)'
        //     }], false),
        //     shadowColor: 'rgba(0, 0, 0, 0.1)',
        //     shadowBlur: 10
        //   }
        // },
        itemStyle: {
          normal: {
            color: 'rgb(175,18,111)',
            borderColor: 'rgba(175,18,111,0.2)',
            borderWidth: this.borderWidth

          }
        }
      }, {
        name: '',
        type: 'line',
        data: null,
        smooth: false,
        symbol: 'circle',
        symbolSize: 5,
        showSymbol: this.showSymbol,
        // areaStyle: {
        //   normal: {
        //     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
        //       offset: 0,
        //       color: 'rgba(18, 175, 140, 0.4)'
        //     }, {
        //       offset: 0.8,
        //       color: 'rgba(137, 189, 27, 0)'
        //     }], false),
        //     shadowColor: 'rgba(0, 0, 0, 0.1)',
        //     shadowBlur: 10
        //   }
        // },
        itemStyle: {
          normal: {
            color: 'rgb(72,18,175)',
            borderColor: 'rgba(72,18,170,0.2)',
            borderWidth: this.borderWidth
          }
        }
      }, {
        name: '',
        type: 'line',
        data: null,
        smooth: false,
        symbol: 'circle',
        symbolSize: 5,
        showSymbol: this.showSymbol,
        // areaStyle: {
        //   normal: {
        //     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
        //       offset: 0,
        //       color: 'rgba(18, 175, 140, 0.4)'
        //     }, {
        //       offset: 0.8,
        //       color: 'rgba(137, 189, 27, 0)'
        //     }], false),
        //     shadowColor: 'rgba(0, 0, 0, 0.1)',
        //     shadowBlur: 10
        //   }
        // },
        itemStyle: {
          normal: {
            color: 'rgb(162,128,145)',
            borderColor: 'rgba(72,18,170,0.2)',
            borderWidth: this.borderWidth
          }
        }
      }
      ],
      unitList: {
        sgChart: 'cm',
        tzChart: 'kg',
        tzzsChart: 'kg/m²',
        xyChart: 'mmHg'
      }
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val)
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      // this.chart = echarts.init(this.$el, 'macarons')
      this.chart = echarts.init(this.$el)
      this.setOptions(this.chartData)
    },
    setSeries(titleNames, dataList) {
      if (titleNames && dataList) {
        let series = []
        series = JSON.parse(JSON.stringify(this.defaultSeries))
        if (series.length >= titleNames.length) {
          for (let i = 0; i < titleNames.length; i++) {
            // series[i].name = titleNames[i]
            series[i].data = dataList[i]
          }
        } else {
          let index = 0
          const seriesLen = series.length
          for (let i = 0; i < titleNames.length; i++) {
            if (i >= seriesLen) {
              index = i % seriesLen
              series.push(JSON.parse(JSON.stringify(this.defaultSeries[index])))
            }
            // series[i].name = titleNames[i]
            series[i].data = dataList[i]
          }
        }
        return series
      }
    },
    setOptions({ titleNames, titles, dataList } = {}) {
      const series = this.setSeries(titleNames, dataList)
      const unitList = this.unitList
      const unitName = this.unitName
      this.chart.setOption({
        xAxis: {
          data: titles,
          // boundaryGap: false,
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          }
        },
        grid: {
          left: 10,
          right: 30,
          bottom: 20,
          top: 30,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          },
          padding: [5, 10],
          formatter(params) {
            let result = params[0].name;
            params.forEach((item, index) => {
              result += "<br/>";
              result +=
                '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:' +
                item.color +
                '"></span>';
              result += titleNames[index] + ": ";
              result += `${item.value}${unitList[`${unitName}`]}`
            });
            return result;
          }
        },
        yAxis: {
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          splitLine: {
            lineStyle: {
              type: 'dashed'
            },
            show: true
          }
        },
        legend: {
          data: titleNames
        },
        series: series
      })
    }
  }
}
</script>
